import React, { FC } from 'react';
import { AvatarWithInfo } from '@src/components/AvatarWithInfo';
import { TextWithReadMore } from '@src/containers/TextWithReadMore';
import { AvatarSize } from '@src/components/Avatar/enums/avatarSize.enum';
import { RepliedCommentProps } from './props';
import './styles.scss';

export const RepliedComment: FC<RepliedCommentProps> = ({ reply }) => {
  const currentCompany = reply?.repliedBy.availableCompanies.find(it => it.isCurrent);

  return (
    <div className="replied-comment fade-in">
      <AvatarWithInfo
        avatarProps={{
          size: AvatarSize.X_LARGE,
          source: currentCompany?.company.profile.logo?.fullUrl,
        }}
        name={reply?.repliedBy.fullName}
        subTitle={reply?.repliedBy.title || ''}
        wrapperClassName="replied-comment__user-info"
      />

      <TextWithReadMore lineLimit={2} text={reply?.comment || ''} textClassName="replied-comment__comment" />
    </div>
  );
};
